/* ==========================================================================
   Hallenbrook storefront behavior — ported from build/hallenbrook.js
   Namespace: data-hbd-*  /  .hbd-*
   Changes from the handoff build:
     - money() now uses the shop's real money_format (window.hbdMoneyFormat)
     - variants resolved from the real {{ product.variants | json }} map
     - add-to-cart posts to /cart/add.js and renders Dawn's cart drawer
     - every module is idempotent so shopify:section:load can't double-bind
   ========================================================================== */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function once(el, key) {
    if (el["__hbd_" + key]) return false;
    el["__hbd_" + key] = true;
    return true;
  }

  /* ------------------------------------------------------------- money --- */

  /* Whole-dollar display (2026-09-29, pdp-v3): mirrors Liquid's
     money_without_trailing_zeros, so 11000 -> $110 and 10999 -> $109.99. */
  function money(cents) {
    var fmt = window.hbdMoneyFormat || "${{amount}}";
    function num(v, precision, thousands, decimal) {
      if (isNaN(v) || v == null) return "0";
      if (precision === 2 && Math.round(v) % 100 === 0) precision = 0;
      v = (v / 100.0).toFixed(precision);
      var parts = v.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents_ = parts[1] ? decimal + parts[1] : "";
      return dollars + cents_;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case "amount": return num(cents, 2, ",", ".");
        case "amount_no_decimals": return num(cents, 0, ",", ".");
        case "amount_with_comma_separator": return num(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return num(cents, 0, ".", ",");
        case "amount_with_space_separator": return num(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return num(cents, 0, " ", ",");
        default: return num(cents, 2, ",", ".");
      }
    });
  }

  /* ----------------------------------------------------------- cart add --- */

  function addToCart(items, button) {
    var drawer = document.querySelector("cart-drawer");
    var body = { items: items };
    if (drawer) {
      body.sections = "cart-drawer,cart-icon-bubble";
      body.sections_url = window.location.pathname;
    }
    var label = button ? button.innerHTML : null;
    if (button) { button.setAttribute("aria-disabled", "true"); }

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || data.message || "Cart error"); }
        if (drawer && data.sections) {
          if (typeof drawer.renderContents === "function") {
            drawer.renderContents(data);
          } else {
            drawer.classList.remove("is-empty");
            if (typeof drawer.open === "function") drawer.open();
          }
        } else {
          window.location.href = "/cart";
        }
        return data;
      })
      .catch(function (err) {
        console.error("[hbd] add to cart failed:", err);
        window.location.href = "/cart";
      })
      .finally(function () {
        if (button) { button.setAttribute("aria-disabled", "false"); if (label) button.innerHTML = label; }
      });
  }

  /* ---------------------------------------------------------- accordion --- */

  function initAccordions() {
    $$("[data-hbd-acc]").forEach(function (item) {
      if (!once(item, "acc")) return;
      var btn = $(".hbd-acc__q", item);
      var panel = $(".hbd-acc__a", item);
      if (!btn || !panel) return;

      setState(btn.getAttribute("aria-expanded") === "true", false);

      btn.addEventListener("click", function () {
        var next = btn.getAttribute("aria-expanded") !== "true";
        var group = item.closest("[data-hbd-acc-single]");
        if (next && group) {
          $$("[data-hbd-acc]", group).forEach(function (other) {
            if (other !== item) closeItem(other);
          });
        }
        setState(next, true);
      });

      function setState(isOpen, animate) {
        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
        item.classList.toggle("is-open", isOpen);
        var sign = $(".hbd-acc__sign", btn);
        if (sign) sign.textContent = isOpen ? "−" : "+";

        if (!isOpen) {
          if (animate && !reduceMotion) {
            panel.style.height = panel.scrollHeight + "px";
            requestAnimationFrame(function () {
              panel.style.transition = "height 200ms ease-out";
              panel.style.height = "0px";
            });
            setTimeout(function () { panel.hidden = true; panel.style.cssText = ""; }, 210);
          } else {
            panel.hidden = true;
            panel.style.cssText = "";
          }
          return;
        }

        panel.hidden = false;
        if (animate && !reduceMotion) {
          var target = panel.scrollHeight;
          panel.style.height = "0px";
          requestAnimationFrame(function () {
            panel.style.transition = "height 200ms ease-out";
            panel.style.height = target + "px";
          });
          setTimeout(function () { panel.style.cssText = ""; }, 210);
        }
      }

      function closeItem(other) {
        var b = $(".hbd-acc__q", other);
        var p = $(".hbd-acc__a", other);
        if (!b || !p) return;
        b.setAttribute("aria-expanded", "false");
        other.classList.remove("is-open");
        p.hidden = true;
        p.style.cssText = "";
        var s = $(".hbd-acc__sign", b);
        if (s) s.textContent = "+";
      }
    });
  }

  /* -------------------------------------------------------- filter pills --- */

  function initFilters() {
    $$("[data-hbd-filter]").forEach(function (group) {
      if (!once(group, "filter")) return;
      var name = group.getAttribute("data-hbd-filter");
      var target = $('[data-hbd-filter-target="' + name + '"]');
      if (!target) return;
      var pills = $$(".hbd-pill", group);

      pills.forEach(function (pill) {
        pill.addEventListener("click", function () {
          pills.forEach(function (p) { p.setAttribute("aria-pressed", p === pill ? "true" : "false"); });
          var val = pill.getAttribute("data-filter");
          var shown = 0;
          $$("[data-tags]", target).forEach(function (card) {
            var tags = (card.getAttribute("data-tags") || "").split(/\s+/);
            var show = val === "all" || tags.indexOf(val) !== -1;
            card.hidden = !show;
            if (show) shown++;
          });
          var empty = $("[data-hbd-filter-empty]", target.parentNode);
          if (empty) empty.hidden = shown !== 0;
        });
      });
    });
  }

  /* ------------------------------------------------------------ gallery --- */

  function initGalleries() {
    $$("[data-hbd-gallery]").forEach(function (root) {
      if (!once(root, "gallery")) return;
      var strip = $(".hbd-gallery__strip", root);
      var thumbs = $$(".hbd-gallery__thumb", root);
      var dots = $$(".hbd-gallery__dot", root);

      function select(i, scroll) {
        thumbs.forEach(function (t, n) { t.setAttribute("aria-current", n === i ? "true" : "false"); });
        dots.forEach(function (d, n) { d.setAttribute("aria-current", n === i ? "true" : "false"); });
        if (strip) {
          Array.prototype.forEach.call(strip.children, function (c, n) {
            c.classList.toggle("is-current", n === i);
          });
        }
        /* Scrolls the strip only (mobile carousel), never the page. The
           offset is measured from the first slide so the strip's own
           position on the page never leaks into the scroll target. */
        if (scroll !== false && strip && strip.children[i]) {
          var left = strip.children[i].offsetLeft - strip.children[0].offsetLeft;
          strip.scrollTo({ left: left, behavior: reduceMotion ? "auto" : "smooth" });
        }
      }

      root.hbdSelectMedia = function (mediaId) {
        if (!strip) return;
        for (var i = 0; i < strip.children.length; i++) {
          if (strip.children[i].getAttribute("data-media-id") === String(mediaId)) { select(i); return; }
        }
      };

      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { select(i); }); });
      dots.forEach(function (d, i) { d.addEventListener("click", function () { select(i); }); });

      if (strip) {
        strip.addEventListener("scroll", function () {
          var i = Math.round(strip.scrollLeft / strip.clientWidth);
          dots.forEach(function (d, n) { d.setAttribute("aria-current", n === i ? "true" : "false"); });
        }, { passive: true });
      }
    });
  }

  /* ----------------------------------------------------------- variants --- */

  function initBuyBlocks() {
    $$("[data-hbd-buy]").forEach(function (root) {
      if (!once(root, "buy")) return;

      var dataEl = $("[data-hbd-variants]", root);
      var variants = [];
      try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }

      var qtyOut = $("[data-hbd-qty]", root);
      var idInput = $("[data-hbd-variant-id]", root);
      var addBtn = $("[data-hbd-add]", root);
      var gallery = $("[data-hbd-gallery]");
      var qty = 1;
      var current = null;

      function selectedValues() {
        var vals = [];
        $$("[data-hbd-optgroup]", root).forEach(function (g) {
          var chosen = $('[data-opt][aria-pressed="true"]', g);
          vals.push(chosen ? chosen.getAttribute("data-value") : null);
        });
        return vals;
      }

      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = [v.option1, v.option2, v.option3];
          var ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== null && opts[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function markAvailability(vals) {
        $$("[data-hbd-optgroup]", root).forEach(function (g, gi) {
          $$("[data-opt]", g).forEach(function (btn) {
            var probe = vals.slice();
            probe[gi] = btn.getAttribute("data-value");
            var v = findVariant(probe);
            if (!v || !v.available) { btn.setAttribute("data-sold-out", ""); }
            else { btn.removeAttribute("data-sold-out"); }
          });
        });
      }

      function sync() {
        var vals = selectedValues();
        var v = findVariant(vals) || variants[0] || null;
        current = v;

        if (variants.length > 1) markAvailability(vals);

        var price = v ? v.price : 0;
        var compare = v && v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;

        $$("[data-hbd-price]", root).forEach(function (el) { el.textContent = money(price); });
        $$("[data-hbd-compare]", root).forEach(function (el) {
          el.textContent = compare ? money(compare) : "";
          el.hidden = !compare;
        });
        $$("[data-hbd-add-price]", root).forEach(function (el) { el.textContent = money(price * qty); });
        if (qtyOut) qtyOut.textContent = String(qty);
        if (idInput && v) idInput.value = v.id;
        var qtyInput = $("[data-hbd-qty-input]", root);
        if (qtyInput) qtyInput.value = String(qty);

        $$("[data-hbd-optlabel]", root).forEach(function (el) {
          var gi = parseInt(el.getAttribute("data-hbd-optlabel"), 10);
          if (vals[gi]) el.textContent = vals[gi];
        });

        if (addBtn) {
          var sellable = v && v.available;
          addBtn.setAttribute("aria-disabled", sellable ? "false" : "true");
          var lbl = $("[data-hbd-add-label]", addBtn);
          if (lbl) lbl.textContent = sellable ? (addBtn.getAttribute("data-label") || "Add to cart") : "Sold out";
        }

        if (v && v.featured_media && gallery && gallery.hbdSelectMedia) {
          gallery.hbdSelectMedia(v.featured_media.id);
        }

        var sticky = $("[data-hbd-sticky]");
        if (sticky) {
          var nameEl = $("[data-hbd-sticky-name]", sticky);
          var sp = $("[data-hbd-sticky-price]", sticky);
          var base = sticky.getAttribute("data-product-name") || "";
          if (nameEl) {
            var vt = variants.length > 1 && v && v.title && v.title !== "Default Title" ? " — " + v.title : "";
            nameEl.textContent = base + vt;
          }
          if (sp) sp.textContent = money(price);
          sticky.hbdVariantId = v ? v.id : null;
        }
      }

      $$("[data-opt]", root).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var g = btn.closest("[data-hbd-optgroup]");
          $$("[data-opt]", g).forEach(function (b) {
            b.setAttribute("aria-pressed", b === btn ? "true" : "false");
          });
          sync();
        });
      });

      var dec = $("[data-hbd-qty-dec]", root);
      var inc = $("[data-hbd-qty-inc]", root);
      if (dec) dec.addEventListener("click", function () { qty = Math.max(1, qty - 1); sync(); });
      if (inc) inc.addEventListener("click", function () { qty = Math.min(99, qty + 1); sync(); });

      if (addBtn) {
        addBtn.addEventListener("click", function (e) {
          e.preventDefault();
          if (!current || !current.available) return;
          addToCart([{ id: current.id, quantity: qty }], addBtn);
        });
      }

      root.hbdCurrent = function () { return { variant: current, qty: qty }; };
      sync();
    });
  }

  /* ------------------------------------------------------------- bundle --- */

  var WORDS = ["none", "one", "two", "three", "four", "five"];

  function initBundles() {
    $$("[data-hbd-bundle]").forEach(function (root) {
      if (!once(root, "bundle")) return;
      var rows = $$("[data-hbd-bundle-item]", root);
      var totalEl = $("[data-hbd-bundle-total]", root);
      var countEl = $("[data-hbd-bundle-count]", root);
      var addBtn = $("[data-hbd-bundle-add]", root);

      function selected() {
        var seen = {}, out = [];
        rows.forEach(function (row) {
          var key = row.getAttribute("data-hbd-bundle-key") || row.getAttribute("data-variant-id");
          if (row.getAttribute("aria-pressed") !== "true" || seen[key]) return;
          seen[key] = true;
          out.push({
            id: parseInt(row.getAttribute("data-variant-id"), 10),
            price: parseInt(row.getAttribute("data-price") || "0", 10)
          });
        });
        return out;
      }

      function sync() {
        var sel = selected();
        var total = sel.reduce(function (a, b) { return a + b.price; }, 0);
        if (totalEl) totalEl.textContent = money(total);
        if (countEl) countEl.textContent = "for " + (WORDS[sel.length] || sel.length) + " selected";
        if (addBtn) addBtn.setAttribute("aria-disabled", sel.length === 0 ? "true" : "false");
      }

      rows.forEach(function (row) {
        row.addEventListener("click", function () {
          var next = row.getAttribute("aria-pressed") !== "true";
          var key = row.getAttribute("data-hbd-bundle-key");
          rows.forEach(function (r) {
            if (r === row || (key && r.getAttribute("data-hbd-bundle-key") === key)) {
              r.setAttribute("aria-pressed", next ? "true" : "false");
            }
          });
          sync();
        });
      });

      if (addBtn) {
        addBtn.addEventListener("click", function (e) {
          e.preventDefault();
          var sel = selected();
          if (!sel.length) return;
          addToCart(sel.map(function (s) { return { id: s.id, quantity: 1 }; }), addBtn);
        });
      }

      sync();
    });
  }

  /* -------------------------------------------------- related products ---
     Shopify only populates `recommendations` when the section is requested
     through the Product Recommendations API, so on first paint the rail is
     empty. Fetch it, and if there is genuinely nothing to recommend hide the
     whole section rather than leaving a heading over an empty rail.
     ---------------------------------------------------------------------- */

  function hideSection(el) {
    var sec = el.closest('.shopify-section, [id^="shopify-section"]');
    if (sec) sec.hidden = true;
  }

  function initRelated() {
    $$("[data-hbd-related]").forEach(function (rail) {
      if (!once(rail, "related")) return;
      var url = rail.getAttribute("data-url");
      if (!url) { hideSection(rail); return; }
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var incoming = doc.querySelector("[data-hbd-related]");
          if (incoming && incoming.children.length) {
            rail.innerHTML = incoming.innerHTML;
          } else {
            hideSection(rail);
          }
        })
        .catch(function () { hideSection(rail); });
    });
  }

  /* --------------------------------------------------------- sticky bar --- */

  function initSticky() {
    var bar = $("[data-hbd-sticky]");
    if (!bar || !once(bar, "sticky")) return;

    var addBtn = $("[data-hbd-sticky-add]", bar);
    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var id = bar.hbdVariantId || parseInt(bar.getAttribute("data-variant-id"), 10);
        if (!id) return;
        addToCart([{ id: id, quantity: 1 }], addBtn);
      });
    }

    var buy = $("[data-hbd-buy]");
    if (!buy || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle("is-visible", !entry.isIntersecting);
      });
    }, { rootMargin: "-120px 0px 0px 0px" }).observe(buy);
  }

  /* ----------------------------------------------------------------- go --- */

  function init() {
    initAccordions();
    initFilters();
    initGalleries();
    initBuyBlocks();
    initBundles();
    initRelated();
    initSticky();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
